import React, { useMemo } from 'react';
import ExcelConnector from './ExcelConnector';
import ApplicationConnector from './ApplicationConnector';
import withStyles from '@mui/styles/withStyles';
import { useMessage } from 'studio/components/Message';
import { useLoader } from 'components/loaders/FadeLoader';
import TroubleConnectingMessage from 'components/TroubleConnectingMessage';
import KnowledgeGraphDBConnectionForm from 'forms/KnowledgeGraphDBConnectionForm/KnowledgeGraphDBConnectionForm';
import PageTitle from 'studio/components/PageTitle';
import styles from './styles';
import CodeSnippet from 'studio/components/CodeSnippet/CodeSnippet';
import Typography from '@mui/material/Typography';

import { useConfirmationModal, useKnowledgeGraph } from 'hooks';

const CreateKnowledgeGraph = props => {
  const { knowledgeGraph, orgSettings, classes, setKnowledgeGraph, connectors, connector, languages, alerts, setStep } =
    props;

  const { withLoader, loading } = useLoader();
  const { successMessage, errorMessage } = useMessage();
  const { showConfirmationModal } = useConfirmationModal();
  const { deleteKnowledgeGraph } = useKnowledgeGraph();

  const additionalButtons = [
    {
      label: 'Back',
      onClick: () => setStep(step => step - 1)
    }
  ];

  const formattedLanguages = useMemo(() => {
    if (languages && languages.length) {
      return languages.map(language => ({
        label: language.data.name,
        value: language.data.id
      }));
    }
    return [];
  }, [languages]);

  const postConnection = () => setStep(step => step + 1);

  const handleDeleteKnowledgeGraph = () => {
    showConfirmationModal(() => {
      return {
        title: 'Delete Knowledge Graph',
        content: (
          <span>
            Are you sure you want to delete the Knowledge Graph&nbsp;
            <span style={{ color: 'var(--primary-color)' }}>{knowledgeGraph.info.default.name}</span>?
          </span>
        ),
        onConfirm: () =>
          deleteKnowledgeGraph({
            withLoader,
            setKnowledgeGraph,
            errorMessage,
            knowledgeGraphId: knowledgeGraph.id
          })
      };
    });
  };

  return (
    <>
      {connector.type === 'DATABASE_CONNECTOR' && (
        <>
          <PageTitle>2 - Add Database Credentials</PageTitle>
          {alerts}
          <Typography variant="body1" gutterBottom component="div">
            Enter the database credentials and ensure that the following IP address of Veezoo is whitelisted by your
            database:
            <CodeSnippet className={classes.ipAddress}>18.158.77.139</CodeSnippet>
          </Typography>
          <KnowledgeGraphDBConnectionForm
            knowledgeGraph={knowledgeGraph}
            orgSettings={orgSettings}
            databases={connectors}
            initialDatabase={connector}
            postConnection={postConnection}
            deleteKnowledgeGraph={handleDeleteKnowledgeGraph}
            successMessage={successMessage}
            errorMessage={errorMessage}
            languages={formattedLanguages}
            additionalButtons={additionalButtons}
            confirmButtonText="Next"
            withLoader={withLoader}
            loading={loading}
            setKnowledgeGraph={setKnowledgeGraph}
            disableDatabaseSelect
            showKnowledgeGraphFields
          />
          <TroubleConnectingMessage />
        </>
      )}
      {connector.type === 'APPLICATION_CONNECTOR' && (
        <ApplicationConnector
          {...props}
          languages={formattedLanguages}
          connector={connector}
          deleteKnowledgeGraph={handleDeleteKnowledgeGraph}
        />
      )}
      {connector.type === 'EXCEL_CONNECTOR' && (
        <ExcelConnector
          {...props}
          languages={formattedLanguages}
          orgSettings={orgSettings}
          connector={connector}
          deleteKnowledgeGraph={handleDeleteKnowledgeGraph}
        />
      )}
    </>
  );
};

export default withStyles(styles)(CreateKnowledgeGraph);
